import { Link } from 'react-router-dom';
import CoinMedia, { SignatureBadge } from '../CoinMedia/CoinMedia';
import styles from './PublicShare.module.css';

// `animate` is only set on the single hero coin of a public coin/collection
// page; tiles and grids always show the static poster.
export function CoinPreview({ coin, size = 'md', legendary = false, animate = false }) {
    const tier = coin?.tier || coin?.reward?.tier || null;
    const source = coin?.reward || coin;
    return (
        <div className={`${styles.coinPreview} ${tier ? styles[`tier_${tier}`] : ''} ${legendary || tier === 'legendary' ? styles.legendaryCoin : ''} ${styles[`coin_${size}`]}`}>
            <div className={styles.coinFace}>
                <CoinMedia
                    coin={source}
                    animate={animate}
                    alt={coin?.title || coin?.reward?.name || 'Aluvo coin'}
                    fallback={<span>🪙</span>}
                />
            </div>
            <SignatureBadge coin={source} compact={size !== 'lg'} className={styles.signatureBadge} />
            {tier && <span className={styles.tierBadge}>{tier === 'legendary' ? 'LEGENDARY' : tier.toUpperCase()}</span>}
        </div>
    );
}

export function PublicCoinTile({ coin }) {
    return (
        <Link to={`/coin/${coin.id}`} className={styles.coinTile}>
            <CoinPreview coin={coin} legendary={coin.tier === 'legendary'} />
            <strong>{coin.title}</strong>
            <span>{coin.tierLabel || coin.tier}</span>
        </Link>
    );
}

export function AchievementItem({ achievement }) {
    return (
        <Link to={`/achievement/${achievement.id}`} className={styles.achievementItem}>
            {achievement.visualUrl ? <img src={achievement.visualUrl} alt="" /> : <span className={styles.achievementIcon}>✦</span>}
            <div>
                <strong>{achievement.title}</strong>
                <small>{formatDate(achievement.date)}</small>
            </div>
        </Link>
    );
}

export function CollectionTile({ collection }) {
    const id = collection.slug || collection.id;
    return (
        <Link to={`/collection/${id}${collection.user?.username ? `?u=${collection.user.username}` : ''}`} className={styles.collectionTile}>
            <CoinPreview coin={{ tier: collection.reward?.tier, coinImageUrl: collection.reward?.coinImageUrl, media: collection.reward?.media, title: collection.reward?.name }} legendary={collection.reward?.tier === 'legendary'} />
            <div>
                <strong>{collection.title}</strong>
                <span>{collection.completed ? 'Completed' : `${collection.progress || 0}/${collection.total || 0} verified`}</span>
            </div>
        </Link>
    );
}

export function PosterStrip({ items = [] }) {
    return (
        <div className={styles.posterStrip}>
            {items.map((item) => (
                <div key={`${item.kind}-${item.tmdbId}-${item.seasonNumber || 'movie'}`} className={`${styles.posterCard} ${item.verified ? styles.verifiedPoster : ''}`}>
                    {item.posterUrl ? <img src={item.posterUrl} alt={item.title} /> : <div className={styles.posterFallback}>🎬</div>}
                    <div>
                        <strong>{item.title}</strong>
                        <span>{item.verified ? `Verified${item.coinTier ? ` · ${item.coinTier}` : ''}` : 'Missing'}</span>
                    </div>
                </div>
            ))}
        </div>
    );
}

function formatDate(date) {
    if (!date) return 'Recently';
    return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(date));
}
